// U+00A0 = non-breaking space

const eur = {
  symbol: '€',
  withDecimals: true,
  thousandSeparator: '\u00A0',
  numberOfDecimals: 2,
  decimalSign: ',',
  minimumStepValue: 0.1,
  format: {
    pos: '%v\u00A0%s',
    neg: '-%v\u00A0%s',
    zero: '%v\u00A0%s',
  },
};

const gbp = {
  symbol: '£',
  withDecimals: true,
  thousandSeparator: ',',
  numberOfDecimals: 2,
  decimalSign: '.',
  minimumStepValue: 0.1,
  format: {
    pos: '%s%v',
    neg: '-%s%v',
    zero: '%s%v',
  },
};

const nok = {
  symbol: ',-',
  withDecimals: false,
  thousandSeparator: '\u00A0',
  numberOfDecimals: 0,
  decimalSign: ',',
  minimumStepValue: 1,
  format: {
    pos: '%v\u00A0%s',
    neg: '-%v\u00A0%s',
    zero: '%v\u00A0%s',
  },
};

const nzd = {
  symbol: '$',
  withDecimals: true,
  thousandSeparator: ',',
  numberOfDecimals: 2,
  decimalSign: '.',
  minimumStepValue: 0.1,
  format: {
    pos: '%s%v',
    neg: '-%s%v',
    zero: '%s%v',
  },
};

const sek = {
  symbol: 'kr',
  withDecimals: false,
  format: {
    pos: '%v\u00A0%s',
    neg: '-%v\u00A0%s',
    zero: '%v\u00A0%s',
  },
  thousandSeparator: '\u00A0',
  numberOfDecimals: 0,
  decimalSign: '.',
  minimumStepValue: 1,
};

const dkk = {
  symbol: 'kr',
  withDecimals: false,
  format: {
    pos: '%v\u00A0%s',
    neg: '-%v\u00A0%s',
    zero: '%v\u00A0%s',
  },
  thousandSeparator: '\u00A0',
  numberOfDecimals: 0,
  decimalSign: '.',
  minimumStepValue: 1,
};

export const CurrencySettings = { eur, gbp, nok, nzd, sek, dkk };
